import React from 'react'
import { TableRow } from '@material-ui/core'
import { StyledTableCell } from '../../commons/utils/TableStyles'

const SafeFeedbackRankingGridRow = (props) => {
	const item = props.item

	return (
		<TableRow>
			<StyledTableCell align="left">{item.posicion}</StyledTableCell>
			<StyledTableCell align="left">{item.conductor}</StyledTableCell>
			<StyledTableCell align="left"><b>{item.puntuacion} pts</b></StyledTableCell>
			<StyledTableCell align="left">{item.total_eventos}</StyledTableCell>
			<StyledTableCell align="left">{item.confirmados}</StyledTableCell>
			<StyledTableCell align="left">{item.desestimados}</StyledTableCell>
		</TableRow>
	)
}

export default SafeFeedbackRankingGridRow
